import { useQuery } from 'react-query';
import { usePersonId } from 'src/components/providers/PersonIdProvider';
import { api } from '../../helpers';
export const useClinicDocuments = ({
  useErrorBoundary,
  enabled = true,
  includeDeprecated = false,
  onlyDeprecated = false
}) => {
  const personReferenceId = usePersonId();
  return useQuery(['clinic_documents', personReferenceId, includeDeprecated, onlyDeprecated], () => api.ana.getClinicDocuments({
    personReferenceId,
    includeDeprecated,
    onlyDeprecated
  }), {
    enabled: Boolean(personReferenceId) && enabled,
    cacheTime: 5 * 60 * 1000,
    useErrorBoundary
  });
};